interface Props {
  title?: string;
  message: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({ title = "暂无符合条件的爆料", message, onReset, resetLabel = "重置筛选" }: Props) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className="ri-inbox-archive-line text-3xl" />
      </span>
      <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-800">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-500">{message}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-5 flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-refresh-line" />
          {resetLabel}
        </button>
      )}
    </div>
  );
}